import { Title } from '../../../../../components/Title';
import claimPayIcon from '../../../../../assets/claim-pay-icon.svg';

export const SuccessTitle = () => <Title title='Sign In Successful'>
  <img alt='claimpay' src={claimPayIcon} />
</Title>;